module.exports = {
	"getListenerAcl": "/api/cps/listenerAcl", // 查询监听器ACL规则列表
	"editListenerAcl": "/api/cps/listenerAcl", // 编辑监听器ACL规则列表
	"listenersDetail": "/api/cps/listeners", // 监听器详情
	"listenerSniList": "/api/cps/listenerSniList", // 查询监听器sni列表
	"serverGroupDetail": "/api/cps/serverGroups", //服务器组详情
	"listenerPrivateConfig":"/api/cps/listenerPrivateConfig", // 监听器个性化配置
};



// WEBPACK FOOTER //
// ./src/api/lb/listener/config.js